import { useState } from 'react';
import { ShowProps } from 'react-admin';
import { useSelector } from 'react-redux';
import { Dialog } from '@/components/dialogs';
import { OverlaidLogoLoader } from '@/components/loaders';
import { AdverseEditDispute, AdverseEditNote } from '@/pages/AdverseAction/actions';
import { Actions } from '@/pages/AdverseAction/view/constants';
import { ShowStyled, TabbedShowLayoutStyled } from '@/pages/AdverseAction/view/styled';
import { AdverseNoticeTab, PreAdverseTab, SummaryTab } from '@/pages/AdverseAction/view/tabs';
import { EditMode } from '@/pages/AdverseAction/view/types';
import { RootState } from '@/store';

const AdverseView = (props: ShowProps) => {
  const { isLoading } = useSelector((state: RootState) => state.turnAdmin);
  const [editMode, setEditMode] = useState<EditMode>(null);
  const toggleEditNote = () => setEditMode((prev) => (prev === 'note' ? null : 'note'));
  const toggleEditDispute = () => setEditMode((prev) => (prev === 'dispute' ? null : 'dispute'));

  const showDefaultView = editMode === null;

  return (
    <ShowStyled
      actions={
        showDefaultView ? <Actions toggleEditNote={toggleEditNote} toggleEditDispute={toggleEditDispute} /> : null
      }
      title="Adverse"
      {...props}
    >
      <Dialog />
      {isLoading && <OverlaidLogoLoader />}
      {editMode === 'note' ? <AdverseEditNote toggleEditNote={toggleEditNote} {...props} /> : null}
      {editMode === 'dispute' ? <AdverseEditDispute toggleEditDispute={toggleEditDispute} {...props} /> : null}
      {showDefaultView ? (
        <TabbedShowLayoutStyled>
          <SummaryTab />
          <PreAdverseTab />
          <AdverseNoticeTab />
        </TabbedShowLayoutStyled>
      ) : null}
    </ShowStyled>
  );
};

export default AdverseView;
